module.exports = __webpack_public_path__ + "img/118.59cb2655.png";